import { PROFILE_HEADER_FOOTER_BAR_BORDERS_WIDTH } from './RentalPortalProfileHeaderFooter.constants'

export function getRentalPortalProfileHeaderFooterActionsVisibleCount({
  actionWidths,
  addNewTextWidth,
  containerWidth,
  moreButtonWidth,
}) {
  const totalActions = actionWidths.length

  const visibleActionsCountOptions = Array.from(
    { length: totalActions + 1 },
    (_, index) => totalActions - index
  )

  for (const visibleActionsCount of visibleActionsCountOptions) {
    const hasMoreButton = visibleActionsCount < totalActions
    const visibleActionsWidth = actionWidths
      .slice(0, visibleActionsCount)
      .reduce((sum, currentWidth) => sum + currentWidth, 0)

    const totalWidth =
      PROFILE_HEADER_FOOTER_BAR_BORDERS_WIDTH +
      addNewTextWidth +
      visibleActionsWidth +
      (hasMoreButton ? moreButtonWidth : 0)

    if (totalWidth <= containerWidth) {
      return visibleActionsCount
    }
  }

  return 0
}

export function getRentalPortalProfileHeaderFooterActionWidths({
  actionButtonRefs,
  actions,
  actionWidthsByKey,
}) {
  const nextActionWidthsByKey = { ...actionWidthsByKey }

  const actionWidths = actions.map(({ action }) => {
    const measuredWidth = actionButtonRefs[action]?.offsetWidth

    if (measuredWidth) {
      nextActionWidthsByKey[action] = measuredWidth
    }

    return nextActionWidthsByKey[action] || 0
  })

  return { actionWidths, actionWidthsByKey: nextActionWidthsByKey }
}

export function getRentalPortalProfileHeaderFooterCachedActionWidths({
  actions,
  actionWidthsByKey,
}) {
  return actions.reduce((accumulator, { action }) => {
    if (actionWidthsByKey[action]) {
      accumulator[action] = actionWidthsByKey[action]
    }

    return accumulator
  }, {})
}
